import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit"
import { api } from "../../environments/environment";
import {  Message } from "@stdoutsrl/design-kit";
import { LoaderService } from "../service/loader.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styles: [],
  standalone: false,
})
export class ChangePasswordComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message
  ) {}

  email: string = "";
  showPassword = false;
  password = "";
  confirmPassword = "";
  token = "";
  app = "";
  acceptTerms = false;

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const token = params.get("token");
    if (token) {
      this.token = token;
    } else {
      this.message.showMessage("Link reset password invalido", "error");
      // this.backToLogin();
    }
  }

  checkboxTerms(event: any) {
    this.acceptTerms = event.checked;
  }

  backToLogin() {
    this.router.navigate(["/login"]);
  }
  changePassword(t:any) {
    if (this.password == this.confirmPassword) {
      this.loader.on();
      this.rest
        .post("/auth/recovery-password/" + this.token, {
          password: this.password,
        })
        .subscribe({
          next: () => {
            this.loader.off(true);
            this.message.showMessage(
              t('passwordChanged'),
              "success",
              "message-fix-index"
            ); 
            this.router.navigate([''])
          },
          error: (error) => {
            this.loader.off(true);
            this.message.showMessage(
              error.error.message,
              "error",
              "message-fix-index"
            );
          },
        });
    } else {
      this.message.showMessage(
        "Password e conferma password devono essere uguali",
        "error",
        "message-fix-index"
      );
    }
  }
}
